import { translatedSchoolGrades, translatedSchoolLevels, translatedSchoolLevelsNames } from "./constants";

export function secondsToTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(remainingSeconds).padStart(2, "0");

    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}

export function parseSearchParams(
    searchParams,
    key,
    parseFunction,
    defaultValue
) {
    const paramValue = searchParams.get(key);
    return paramValue ? parseFunction(paramValue) : defaultValue;
}

export function convertURLParams(url) {
    // Check if the URL contains "page"

    if (url.includes("page")) {
        // Decode the URL
        const decodedURL = decodeURIComponent(url);

        // Split the URL into the base part and query string part
        const [base, queryString] = decodedURL.split("?");
        if (!queryString) return base;

        // Split the query parameters
        const params = queryString.split("&");

        // Filter out the "page" parameter
        const filteredParams = [];
        for (const param of params) {
            if (!param.startsWith("page=")) {
                filteredParams.push(param);
            }
        }

        // Reconstruct the URL
        return filteredParams.length > 0
            ? `${base}?${filteredParams.join("&")}`
            : base;
    }

    // Decode and replace specific characters
    const decodedURL = decodeURIComponent(url);
    const replacedURL = decodedURL.replace(/%5B/g, "[").replace(/%5D/g, "]");
    return replacedURL;
}

// input "2024-04-11T04:46:23.000000Z" // Output: "Apr 11, 2024 4:46:23 AM"
export function formatDateTime(dateTimeString) {
    const dateTime = new Date(dateTimeString);
    // Format the date
    const formattedDate = dateTime.toLocaleDateString("ar", {
        year: "numeric",
        month: "short",
        day: "2-digit",
    });
    // Format the time
    const formattedTime = dateTime.toLocaleTimeString("ar", {
        hour12: true,
        hour: "2-digit",
        minute: "2-digit",
        // second: "2-digit",
    });
    return { formattedDate, formattedTime };
}
//input "12345.67" // Output: "ج.م12,345.67"
export function formatCurrency(value) {
    const formatter = new Intl.NumberFormat("ar-EG", {
        style: "currency",
        currency: "EGP",
        // minimumFractionDigits: 0,
    });
    return formatter.format(value);
}

// convert youTupe video link to embed link
export function convertToEmbedLink(url) {
    // YouTube
    const ytRegExp =
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

    const ytMatch = url.match(ytRegExp);
    if (ytMatch) {
        return `https://www.youtube.com/embed/${ytMatch[1]}`;
    }

    // Vimeo (supports vimeo.com, player.vimeo.com, with or without params)
    const vimeoRegExp =
        /(?:https?:\/\/)?(?:www\.)?(?:player\.)?vimeo\.com\/(?:video\/)?(\d+)/;

    const vimeoMatch = url.match(vimeoRegExp);
    if (vimeoMatch) {
        return `https://vimeo.com/${vimeoMatch[1]}`;
    }

    return null;
}


export const SearchParams = ({ paramsObject = {} }) => {
    const entries = Object.entries(paramsObject).filter(([_, value]) => value !== undefined && value !== "");
    if (!entries.length) return "";

    const query = entries.map(([key, value]) => Array.isArray(value) ? `${key}=${value.join(",")}` : `${key}=${value}`).join("&");
    return `?${query}`;
};


export const formatSchoolLevels = (data) => {
    const schoolLevels = {};
    data?.length && data.forEach(item => {
        const { school_level, grade, description } = item.attributes;

        if (!schoolLevels[school_level]) {
            schoolLevels[school_level] = {
                school_level: school_level,
                school_level_name: translatedSchoolLevelsNames[school_level],
                grades: []
            };
        }

        schoolLevels[school_level].grades.push({
            value: grade,
            label: `${translatedSchoolGrades[grade]} ${translatedSchoolLevels[school_level]}`,
            id: item.id,
            description: description
        });
    });
    return Object.values(schoolLevels).map(level => ({
        ...level,
        grades: level.grades.sort((a, b) => a - b)
    }));
}

